import UserByCountryMap from "../components/UserByCountryMap.js";
import DeviceAnalysisChart from "../components/DeviceAnalysisChart.js";
import BrowserOS from "../components/BrowserOS.js";
import Langauge from "../components/Language.js";
import Layout from "./layout.js";
import { Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Col from "react-bootstrap/Col";
import DateInput from "../components/DateInput.js";
import Button from "../components/Button.js";

const UserProfileAnalytics = () => {
    const navigate = useNavigate();
    const handleRefresh = () => {
        window.location.reload(); // This will refresh the page
    };

    return (
        <Layout>
            <div className="d-flex align-items-center justify-content-between">

                <div className="mt-3 d-flex align-items-center">
                    <div className="d-flex gap-5 md-date">
                        <DateInput label="" type="range" includeTime={false} />
                    </div>

                    {/* Refresh Button */}
                    <div className=" mb-2 ps-3 md-refresh ">
                        <i
                            className="bi bi-arrow-repeat icon-refresh"
                            onClick={handleRefresh}
                        ></i>
                    </div>
                </div>
                <div className="text-right gap-3 ie-btn d-flex">
                    <Button
                        buttonType="^"
                        onClick={() => navigate("/add-usersegment")}
                        label="User Segment"
                    />
                </div>

            </div>
            <Row>
                <Col md={7}>
                    <div style={{ background: "#fff", padding: "20px", borderRadius: "12px" }}>
                        <h3>Users By Country</h3>
                        <UserByCountryMap/>
                    </div>
                </Col>

                <Col md={5}>
                    <div style={{ background: "#fff", padding: "20px", borderRadius: "12px" }}>
                        <h3>Device Analysis</h3>
                        <DeviceAnalysisChart/>
                    </div>
                </Col>

            </Row>

            <Row>
                <Col md={7}>
                    <div style={{ background: "#fff", padding: "20px", borderRadius: "12px", marginTop: "20px"}}>
                        <h3>Browser And Operating System </h3>
                        <BrowserOS/>
                    </div>

                </Col>

                <Col md={5}>
                    <div style={{ background: "#fff", padding: "20px", borderRadius: "12px", marginTop: "20px" }}>
                        <h3>Languages</h3>
                        <Langauge/>
                    </div>
                </Col>
            </Row>
        </Layout>
    );
}
export default UserProfileAnalytics;

